"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Thor = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _utils = _interopRequireDefault(require("./utils"));
var _gtm = _interopRequireDefault(require("./gtm"));
var _tealium = _interopRequireDefault(require("./tealium"));
var dlFunctions = _interopRequireWildcard(require("./dataLayerFunctions"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var listeners = {
    events: [],
    variables: []
  },
  plugins = {},
  _version = "3.2.1";
var pendings = [];

/**
 * Thor class
 * @module Thor
 * @class
 */
var Thor = /*#__PURE__*/function () {
  function Thor() {
    (0, _classCallCheck2["default"])(this, Thor);
    if (Thor.instance) {
      throw new Error("This constructor has already been called");
    }
    /**
     * dataLayer of the library. </br>
     * That is the array who's the interface between the site and TMS.
     * @memberof Thor
     * @member {Object} dataLayer
     */
    this.dataLayer = {};

    /**
     * Thor testing active status.
     * @memberof Thor
     * @member {Boolean} isTestingMode
     */
    this.isTestingMode = false;

    /**
     * Version of the library
     * @memberof Thor
     * @member {String} version
     */
    this.version = process.env.NODE_ENV === "production" ? _version : "dev";
    typeof document !== "undefined" && this.checkTesting();

    /**
     * Flag to check if the library received the consent event or not.
     * @memberof Thor
     * @member {Bool}
     */
    this.hasConsent = false;
  }

  /**
   * Launch the debug mode if the flag is set
   * If the flag match "-stage" launch stage version else launch prod's version
   * @async
   */
  (0, _createClass2["default"])(Thor, [{
    key: "checkTesting",
    value: function () {
      var _checkTesting = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this = this;
        var config;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = new URLSearchParams(document.location.search).get("testingThor") || window.localStorage.getItem("testingThor") || this.plugins.utils.loadCookie("testingThor");
              if (!!config) {
                this.loadScript(config.indexOf("-stage") !== -1 ? "//website-assets-stage.dignp.com/thor/stage-testingThor.js" : "//website-assets.seloger.com/thor/prod-testingThor.js").then(function () {
                  if (typeof ThorTesting === "function") {
                    _this.testing = ThorTesting(config.replace("-stage", ""));
                    _this.isTestingMode = true;
                  }
                })["catch"](function (err) {
                  throw new Error(err);
                });
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function checkTesting() {
        return _checkTesting.apply(this, arguments);
      }
      return checkTesting;
    }()
    /**
     * Create a script tag and load it on the path param's
     * @param {String} path
     */
  }, {
    key: "loadScript",
    value: function loadScript(path) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = path;
        document.head.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
      });
    }

    /**
     * Get the dataLayer value of a given key.
     * @param {String} key - The key to find into the thor's dataLayer
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the
     * @return {*} Return the value that matches the key, default value is an empty string.
     */
  }, {
    key: "getDataLayerValue",
    value: function getDataLayerValue(key) {
      var dl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.dataLayer;
      return dlFunctions.getDataLayerValue(dl, key);
    }

    /**
     * Return the object on the dataLayer, matching the combo
     * key:value passed in params.
     * @param {String} key - Name of the key in the thor's dataLayer
     * @param {String} val - Value to test with the key's name
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the
     * @return {Object}
     * Return the object of the dataLayer matching the combo key:value,
     * else return false.
     */
  }, {
    key: "getDataLayerObject",
    value: function getDataLayerObject(key, val) {
      var dl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.dataLayer;
      return dlFunctions.getDataLayerObject(dl, key, val);
    }

    /**
     * Check if an element exist in the dataLayer.
     * @param {String} key - Name of the key in the thor's dataLayer
     * @param {String} val - Value to test with the key's name
     * @param {Array|Object} [dl=dataLayer] - The context to launch the search, by default the
     * @return {Boolean}
     * Return True if the combo key: value exist in the dataLayer array,
     * else return false.
     */
  }, {
    key: "inDataLayer",
    value: function inDataLayer(key, val) {
      var dl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.dataLayer;
      return dlFunctions.inDataLayer(dl, key, val);
    }

    /**
     * Add value into the dataLayer.
     * @param {Object} obj - The object to merge with the dataLayer
     */
  }, {
    key: "push",
    value: function push(obj) {
      this.dataLayer = _objectSpread(_objectSpread({}, this.dataLayer), obj);
    }

    /**
     * Push a non event object into the dataLayer.
     * @param {Object} obj - The oject to add into the dataLayer
     */
  }, {
    key: "pushVariable",
    value: function pushVariable(obj) {
      if (!this.hasConsent) {
        pendings.push({
          evt: 0,
          data: obj
        });
      } else {
        this.push(obj);
        for (var i = 0, l = listeners.variables.length; i < l; ++i) {
          listeners.variables[i](obj);
        }
      }
    }

    /**
     * Push an event into the dataLayer, with an optional object to add into the dataLayer.
     * @param {String} evt - The event to launch.
     * @param {Object} [args] - The oject to add into the dataLayer.
     */
  }, {
    key: "pushEvent",
    value: function pushEvent(evt, args) {
      if (!this.hasConsent) {
        pendings.push({
          evt: evt,
          data: args
        });
      } else {
        this.isTestingMode && !!this.testing && this.testing(evt, _objectSpread(_objectSpread({}, this.dataLayer), args));
        if (!!args) {
          this.pushVariable(args);
        }
        if (typeof evt === "function") {
          evt = evt();
        }
        this.push({
          event: evt
        });
        for (var i = 0, l = listeners.events.length; i < l; ++i) {
          listeners.events[i](evt);
        }
      }
    }

    /**
     * Callback that allows you to unstack the pending tracking.
     */
  }, {
    key: "onConsent",
    value: function onConsent() {
      var _this2 = this;
      this.hasConsent = true;
      pendings.forEach(function (args, id) {
        if (args.evt) {
          _this2.pushEvent(args.evt, args.data);
        } else {
          _this2.pushVariable(args.data);
        }
      });
      pendings = [];
    }

    /**
     * Return the existing instance of Thor class or create a new one.
     * @returns {object} The Thor instance.
     */
  }, {
    key: "plugins",
    get:
    /**
     * Return the plugins' list.
     * @namespace Thor.plugins
     * @memberof Thor
     * @returns {Array} The plugins' list added to the Thor instance.
     */
    function get() {
      return _objectSpread({}, plugins);
    }

    /**
     * Return the current pendings array.
     * @memberof Thor
     * @returns {Array} The current pendings list of tracking element.
     */
  }, {
    key: "pendings",
    get: function get() {
      return pendings;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (typeof window === "undefined") return;
      this.instance = this.instance || new Thor();
      window.thor = window.thor || this.instance;
      return window.thor;
    }

    /**
     * Add plugin to the Thor instance.
     * @param {String} name - The name of the plugin to add.
     * @param {function} pluginCtor - The constructor of the plugin.
     */
  }, {
    key: "register",
    value: function register(name, pluginCtor) {
      plugins[name] = pluginCtor(Thor);
    }

    /**
     * Add callback function to add variables into dataLayer.
     * @param {function} listener - The callback's function.
     */
  }, {
    key: "addVariablesListener",
    value: function addVariablesListener(listener) {
      listeners.variables.push(listener);
    }

    /**
     * Add callback function to add event into dataLayer.
     * @param {function} listener - The callback's function.
     */
  }, {
    key: "addEventsListener",
    value: function addEventsListener(listener) {
      listeners.events.push(listener);
    }
  }]);
  return Thor;
}();
exports.Thor = Thor;
if (!Thor.hasOwnProperty("instance")) {
  Thor.instance = null;
}
Thor.register("utils", _utils["default"]);
Thor.register("GTM", _gtm["default"]);
Thor.register("Tealium", _tealium["default"]);
var _default = Thor.getInstance();
exports["default"] = _default;